function swipersInit() {
  const bannerSlider = new Swiper('.swiper-banners', {
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    // navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    // },
    pagination: {
      el: '.swiper-pagination',
      clickable: false
  },
    breakpoints: {
      992: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      }
    }
    
  })


  const carDropdownCSwiper = new Swiper ('.car-dropdown-c-swiper', {
    slidesPerView: 3,
    spaceBetween: 20,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    }
  })

  const awardsSwiper = new Swiper ('.awards-swiper', {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next.button-next-awards',
      prevEl: '.swiper-button-prev.button-prev-awards',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  })

  const categoriesSwiper = new Swiper ('.categories-swiper', {
    slidesPerView: 4,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next.button-next-category',
      prevEl: '.swiper-button-prev.button-prev-category',
    },
    breakpoints: {
      768: {
        slidesPerView: 5,
      },
    },
  })

  const promotionSwiper = new Swiper ('.promotion-swiper', {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next.button-next-promotion',
      prevEl: '.swiper-button-prev.button-prev-promotion',
    },
    breakpoints: {
      700: {
        slidesPerView: 2,
        spaceBetween: 15
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  })

  const carVersionSwiper = new Swiper ('.car-version-swiper', {
    slidesPerView: 1,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next.button-next-version',
      prevEl: '.swiper-button-prev.button-prev-version',
    },
    breakpoints: {
      1500: {
        slidesPerView: 6,
        spaceBetween: 15
      },
      1300: {
        slidesPerView: 4,
        spaceBetween: 15
      },
      1050: {
        slidesPerView: 3,
        spaceBetween: 15
      },
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  })

  const newCarsSwiper = new Swiper('.new-cars-swiper', {
    slidesPerView: 1,
    setWrapperSize: true,
    watchOverflow :true,
    navigation: {
      nextEl: '.swiper-button-next.new-cars',
      prevEl: '.swiper-button-prev.new-cars',
    },
    pagination: {
      el: '.swiper-pagination.new-cars',
      clickable: true
    },
  })

  const directSaleSwiper = new Swiper('.direct-sale-swiper', {
    slidesPerView: 1,
    // centerInsufficientSlides: true,
    watchOverflow :true,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next.direct-sale',
      prevEl: '.swiper-button-prev.direct-sale',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    breakpoints: {
      900: {
        slidesPerView: $('.direct-sale-swiper').data('slides'),
      },
      1600: {
        slidesPerView: $('.direct-sale-swiper').data('slides') + 1,
      }
    }
  })

  const usedCarsSwiper = new Swiper('.used-cars-swiper', {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: '.swiper-pagination.used-car',
      clickable: true
    },
    breakpoints: {
      900: {
        slidesPerView: 2,
      },
      1300: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next.used-car',
      prevEl: '.swiper-button-prev.used-car',
    },
  })

  const localSlider = new Swiper('.local-swiper', {
    slidesPerView: 1,
    navigation: {
        nextEl: '.swiper-button-next.local',
        prevEl: '.swiper-button-prev.local',
    },
    pagination: {
      el: '.swiper-pagination.local',
      clickable: true
  },
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
  })

  const sliderUsedInternalThumbs = new Swiper('.used-internal-slider-thumbs', {
    slidesPerView: 3,
    freeMode: true,
    spaceBetween: 60,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.slider-used-thumb-next',
      prevEl: '.swiper-button-prev.slider-used-thumb-prev',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
  });

  const sliderUsedInternal = new Swiper('.used-internal-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.slider-used-next',
      prevEl: '.swiper-button-prev.slider-used-prev',
    },
    clickable: true,
    thumbs: {
      swiper: sliderUsedInternalThumbs
    }
  });

  const sliderUsedRelated = new Swiper('.slider-used-related', {
    clickable: true,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination.related',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next.related',
      prevEl: '.swiper-button-prev.related',
    },
    watchOverflow: true,
    observer:true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow :true,
  });

  const phonesSwiper = new Swiper('.phones-swiper', {
    slidesPerView: 1,
    autoplay: {
        delay: 5000,
    },
    loop: true,
    navigation:{
      nextEl: '.swiper-button-next.phones',
      prevEl: '.swiper-button-prev.phones'
    }
  });
}

module.exports = {
  swipersInit
}
